module.exports = __webpack_public_path__ + "img/package_bind_phone.9092cbbc.png";